/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import './activity-calendar.css';
import Moment from 'moment';
import { COMMON, API_CONSTANTS, ALL_ROUTES, SAMPLE_TO_SALE_SCREEN } from '../../global/Constants';
import { HeaderTypes, ActivityType, S2S_CROP, S2S_STAGE, CROP_GROUP } from "../../global/Enum";
import Header from '../common/Header';
import Footer from '../common/Footer';
import DesktopFooter from '../common/DesktopFooter';
import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
import ActivityHeader from '../common/ActivityHeader';
import AcceptRejectButton from '../common/AcceptRejectButton';

import SowingTransplantationView from '../SampleToSale/SowingTransplantationView';
import TransplantationView from '../SampleToSale/TransplantationView';
import FieldDayView from '../SampleToSale/FieldDayView';
import PlotVisitView from '../SampleToSale/PlotVisitView';
import HarvestCottonView from '../SampleToSale/HarvestCottonView';
import HarvestRiceView from '../SampleToSale/HarvestRiceView';
import HarvestMilletView from '../SampleToSale/HarvestMilletView';
import FieldDamageView from '../SampleToSale/FieldDamageView';
import HarvestVegView from '../SampleToSale/HarvestVegView';
import GerminationView from '../SampleToSale/GerminationView';
import FruitQualityView from '../SampleToSale/FruitQualityView';
import PestDiseaseView from '../SampleToSale/PestDiseaseView';

import SyncLoader from '../common/loader/SyncLoader';
import DataProvider from '../../providers/DataProvider';


class SampleToSaleDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStage: 1,
            isLoading: false,
            activity: {},
            data: {},

            sowingStage: {},
            plotVisitStage: {},
            fieldDayStage: null,
            harvestDetailStage: null,
            fieldDamageStage: null,
            germinationStage: null,
            fruitQualityStage: null,
            pestDiseaseStage: null
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                let activity = this.props.location.state.data;
                this.setState({ activity: activity, activeStage: activity?.stage_id });
                Utilities.LogPrint("Data:-->", activity);
                this.getActivityById(activity.activity_id);

            } else {
                this.props.history.replace(ALL_ROUTES.CALENDAR_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    isVegCrop = () => {
        const { activity } = this.state;
        const crop = DataProvider.getInstance().getCropById(activity.crop_id);
        //Utilities.LogPrint("Crop", crop);
        if (crop?.crop_group_id === CROP_GROUP.VEGETABLE_CROPS) {
            return true;
        } else {
            return false;
        }
    }


    handleBack = () => {
        this.props.history.goBack();
    }

    getActivityById(id) {
        this.setState({ isLoading: true });
        const request = JSON.stringify({
            activity_id: id
        });
        try {
            ApiServices.getActivityById(request)
                .then(response => {
                    Utilities.LogPrint("Sample To Sale DATA: ---->", response);
                    this.setState({ isLoading: false });
                    if (response.success) {
                        const data = response.data;
                        if (data != null) {
                            this.setState({
                                data: data,
                                sowingStage: data?.history?.stage_one?.[0],
                                transplantationStage: data?.history?.stage_two?.[0],
                                plotVisitStage: data?.history?.stage_three,
                                fieldDayStage: data?.history?.stage_four?.[0],
                                harvestDetailStage: data?.history?.stage_five,
                                fieldDamageStage: data?.history?.stage_six?.[0],
                                germinationStage: data?.history?.stage_eight?.[0],
                                fruitQualityStage: data?.history?.stage_nine?.[0],
                                pestDiseaseStage: data?.history?.stage_ten?.[0],
                            });
                        }
                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                    }
                }).catch(error => {
                    this.setState({ isLoading: false });
                });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }


    getFormattedDate() {
        let selectedDate = null;
        if (this.props.location.state !== undefined) {
            selectedDate = this.props.location.state.selectedDate;
            return Moment(selectedDate).format('dddd, DD MMM, yyyy');
            //return Moment(new Date()).format('dddd, DD MMM, yyyy');
        }
    }

    handleChangeTab = (type) => {
        Utilities.LogPrint("Type", type);
        this.setState({
            activeStage: type,
        });
    }

    handleAcceptButton = () => {
        this.props.history.goBack();
    }

    handleRejectButton = () => {
        this.props.history.goBack();
    }

    setActivityName(stageId) {
        switch (stageId) {
            case S2S_STAGE.SOWING_AND_TRANSPLANTATION:
                return SAMPLE_TO_SALE_SCREEN.SOWING;
            case S2S_STAGE.TRANSPLANTATION:
                return SAMPLE_TO_SALE_SCREEN.TRANSPLANTATION;
            case S2S_STAGE.PLOT_VISIT:
                return SAMPLE_TO_SALE_SCREEN.PLOT_VISIT;
            case S2S_STAGE.FIELD_DAY:
                return SAMPLE_TO_SALE_SCREEN.FIELD_DAY;
            case S2S_STAGE.HARVEST_DETAILS:
                return SAMPLE_TO_SALE_SCREEN.HARVEST_DETAILS;
            default:
                break;
        }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName)
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, isSyncLoading, tableName, activeStage, data, activity, sowingStage, transplantationStage, plotVisitStage, fieldDayStage, harvestDetailStage, fieldDamageStage,
            germinationStage, fruitQualityStage, pestDiseaseStage } = this.state;
        const krishak = data?.krishak;

        return (
            <div>
                <Header selectedTab={HeaderTypes.CALENDAR} handleSyncLoading={this.handleSyncLoading} />
                <Footer isActive={1} />

                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="title mb-0">{this.getFormattedDate()} Activities for {data?.user_name}</h3>
                            <p className="sub-title">{activity?.tehsil_name}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-6 col-lg-7 col-md-9 col-12 my-3">
                            <ActivityHeader
                                type={ActivityType.SAMPLE_TO_SALE}
                                code={activity?.activity_tag}
                                title={activity.activity_type_name}
                                //title={activity.activity_type_name + " - " + this.setActivityName(activity?.stage_id)}
                                subTitle={activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name} />

                            {/* <div className="activity-info-box green-activity mb-3 text-white">
                                <span>S2S2771</span>
                                <h5>{HOME_TODAY_SCREEN.SAMPLE_TO_SALE}</h5>
                                <span>CROP, HYBRID | Village</span>
                            </div> */}
                        </div>
                        <div className="col-xl-6 col-lg-5 col-md-3 d-md-flex back-btn mt-3 d-none">
                            <button className="btn btn-secondary min-w-182 krishak-cancel-btn" onClick={this.handleBack}>{COMMON.BACK}</button>
                        </div>
                    </div>

                    {/* Reject Reason */}
                    {/* {
                        data.activity_reject && data.activity_status_id === 4 ?
                            <div className="row">
                                <div className="col-12 reject-activity-msg">
                                    <i className="customic ic-rejected"></i>
                                    <span>{data?.activity_reject?.reject?.title}</span>
                                </div>
                            </div> : null
                    } */}

                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="row mb-3">
                                <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">{COMMON.FARMER_NAME}</div>
                                <div className="col-lg-12 col-7">
                                    <span className="d-block font-weight-medium">{krishak?.name}</span>
                                    <span className="d-block font-weight-medium">+91 - {krishak?.phone}</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-12 d-none">
                            <div className="row mb-3">
                                <div className="col-lg-12 col-5 pr-0 pr-md-3 mb-md-2">Location</div>
                                <div className="col-lg-12 col-7">
                                    <span className="d-block font-weight-medium">Unnamed Road, Amargarh, Haryana 126116, India</span>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-lg-4 mb-md-3">
                            <ul className="general-info-menu">
                                <li className={activeStage === S2S_STAGE.SOWING ? 'active' : ''} data-tab="showingDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.SOWING_AND_TRANSPLANTATION) }}>{SAMPLE_TO_SALE_SCREEN.SOWING} <i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeStage === S2S_STAGE.TRANSPLANTATION ? 'active' : '' || (transplantationStage === undefined || transplantationStage === null ? 'd-none' : '')} data-tab="transplantationDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.TRANSPLANTATION) }}>{SAMPLE_TO_SALE_SCREEN.TRANSPLANTATION} <i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeStage === S2S_STAGE.GERMINATION ? 'active' : '' || (germinationStage === undefined || germinationStage === null ? 'd-none' : '')} data-tab="germinationDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.GERMINATION) }}>{SAMPLE_TO_SALE_SCREEN.GERMINATION} <i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeStage === S2S_STAGE.FRUIT_QUALITY ? 'active' : '' || (fruitQualityStage === undefined || fruitQualityStage === null ? 'd-none' : '')} data-tab="fruitQualityDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.FRUIT_QUALITY) }}>{SAMPLE_TO_SALE_SCREEN.FRUIT_QUALITY} <i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeStage === S2S_STAGE.PEST_AND_DISEASE ? 'active' : '' || (pestDiseaseStage === undefined || pestDiseaseStage === null ? 'd-none' : '')} data-tab="pestDiseaseDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.PEST_AND_DISEASE) }}>{SAMPLE_TO_SALE_SCREEN.PEST_AND_DISEASE} <i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeStage === S2S_STAGE.PLOT_VISIT ? 'active' : '' || (plotVisitStage === undefined || plotVisitStage === null ? 'd-none' : '')} data-tab="plotDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.PLOT_VISIT) }}>{SAMPLE_TO_SALE_SCREEN.PLOT_VISIT} <i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeStage === S2S_STAGE.FIELD_DAY ? 'active' : '' || (fieldDayStage === undefined || fieldDayStage === null ? 'd-none' : '')} data-tab="fieldDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.FIELD_DAY) }}>{SAMPLE_TO_SALE_SCREEN.FIELD_DAY}<i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeStage === S2S_STAGE.HARVEST_DETAILS ? 'active' : '' || (harvestDetailStage === undefined && harvestDetailStage !== null ? 'd-none' : '')} data-tab="harvestDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.HARVEST_DETAILS) }}>{SAMPLE_TO_SALE_SCREEN.HARVEST_DETAILS} <i className="customic ic-go-button ml-auto"></i></li>
                                <li className={activeStage === S2S_STAGE.FIELD_DAMAGE ? 'active' : '' || (fieldDamageStage === null || fieldDamageStage === undefined ? 'd-none' : '')} data-tab="fieldDamage" onClick={() => { this.handleChangeTab(S2S_STAGE.FIELD_DAMAGE) }}>{SAMPLE_TO_SALE_SCREEN.FIELD_DAMAGE} <i className="customic ic-go-button ml-auto"></i></li>
                            </ul>
                        </div>

                        <div className="col-lg-8" id="generalInfoForm">
                            <div className="accordion">

                                {/* Sowing and Transplantation */}
                                <div id="showingDetailsHeading" className="d-md-none accordion-heading">
                                    <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#showingDetails" aria-expanded="false" aria-controls="showingDetails" >
                                        {SAMPLE_TO_SALE_SCREEN.SOWING}
                                        <i className="customic ic-down-arrow ml-auto"></i>
                                    </a>
                                </div>
                                <div id="showingDetails" className={`collapse ${activeStage === S2S_STAGE.SOWING ? 'accordion-body show ' : ''}`} aria-labelledby="showingDetailsHeading" data-parent="#generalInfoForm">
                                    <SowingTransplantationView sowingStage={sowingStage} isVegCrop={this.isVegCrop()} />
                                </div>


                                {/* Transplantation */}
                                {transplantationStage !== undefined && transplantationStage !== null ?
                                    <div>
                                        <div id="transplantationDetailsHeading" className="d-md-none accordion-heading">
                                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#transplantationDetails" aria-expanded="false" aria-controls="transplantationDetails" >
                                                {SAMPLE_TO_SALE_SCREEN.TRANSPLANTATION}
                                                <i className="customic ic-down-arrow ml-auto"></i>
                                            </a>
                                        </div>
                                        <div id="transplantationDetails" className={`collapse ${activeStage === S2S_STAGE.TRANSPLANTATION ? 'show accordion-body' : ''}`} aria-labelledby="transplantationDetailsHeading" data-parent="#generalInfoForm">
                                            <TransplantationView transplantationStage={transplantationStage} isVegCrop={this.isVegCrop()} />
                                        </div>
                                    </div> : null
                                }

                                {/* Germination */}
                                {germinationStage !== undefined && germinationStage !== null ?
                                    <div>
                                        <div id="germinationHeading" className="d-md-none accordion-heading">
                                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#germinationDetails" aria-expanded="false" aria-controls="germinationDetails" >
                                                {SAMPLE_TO_SALE_SCREEN.GERMINATION}
                                                <i className="customic ic-down-arrow ml-auto"></i>
                                            </a>
                                        </div>
                                        <div id="germinationDetails" className={`collapse ${activeStage === S2S_STAGE.GERMINATION ? 'show accordion-body' : ''}`} aria-labelledby="germinationHeading" data-parent="#generalInfoForm">
                                            <GerminationView germinationStage={germinationStage} />
                                        </div>
                                    </div> : null
                                }

                                {/* Fruit Quality */}
                                {fruitQualityStage !== undefined && fruitQualityStage !== null ?
                                    <div>
                                        <div id="fruitQualityHeading" className="d-md-none accordion-heading">
                                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#fruitQualityDetails" aria-expanded="false" aria-controls="fruitQualityDetails" >
                                                {SAMPLE_TO_SALE_SCREEN.FRUIT_QUALITY}
                                                <i className="customic ic-down-arrow ml-auto"></i>
                                            </a>
                                        </div>
                                        <div id="fruitQualityDetails" className={`collapse ${activeStage === S2S_STAGE.FRUIT_QUALITY ? 'show accordion-body' : ''}`} aria-labelledby="fruitQualityHeading" data-parent="#generalInfoForm">
                                            <FruitQualityView fruitQualityStage={fruitQualityStage} />
                                        </div>
                                    </div> : null
                                }

                                {/* Pest & Disease */}
                                {pestDiseaseStage !== undefined && pestDiseaseStage !== null ?
                                    <div>
                                        <div id="pestDiseaseHeading" className="d-md-none accordion-heading">
                                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#pestDiseaseDetails" aria-expanded="false" aria-controls="pestDiseaseDetails" >
                                                {SAMPLE_TO_SALE_SCREEN.PEST_AND_DISEASE}
                                                <i className="customic ic-down-arrow ml-auto"></i>
                                            </a>
                                        </div>
                                        <div id="pestDiseaseDetails" className={`collapse ${activeStage === S2S_STAGE.PEST_AND_DISEASE ? 'show accordion-body' : ''}`} aria-labelledby="pestDiseaseHeading" data-parent="#generalInfoForm">
                                            <PestDiseaseView pestDiseaseStage={pestDiseaseStage} />
                                        </div>
                                    </div> : null
                                }

                                {/* Plot Visit */}
                                {plotVisitStage !== undefined && plotVisitStage !== null ?
                                    <div>
                                        <div id="plotDetailsHeading" className="d-md-none accordion-heading">
                                            <a href="" data-toggle="collapse" data-target="#plotDetails" aria-expanded="false" aria-controls="plotDetails" className="font-weight-medium d-flex w-100 align-items-center my-3" >
                                                {SAMPLE_TO_SALE_SCREEN.PLOT_VISIT}
                                                <i className="customic ic-down-arrow ml-auto"></i>
                                            </a>
                                        </div>
                                        <div id="plotDetails" className={`collapse ${activeStage === S2S_STAGE.PLOT_VISIT ? 'show accordion-body' : ''}`} aria-labelledby="plotDetailsHeading" data-parent="#generalInfoForm">
                                            <PlotVisitView plotVisitStage={plotVisitStage} />
                                        </div>
                                    </div> : null
                                }

                                {/* Field Day */}
                                {fieldDayStage !== undefined && fieldDayStage !== null ?
                                    <div>
                                        <div id="fieldDetailsHeading" className="d-md-none accordion-heading">
                                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3 bold" data-toggle="collapse" data-target="#fieldDetails" aria-expanded="false" aria-controls="fieldDetails">
                                                {SAMPLE_TO_SALE_SCREEN.FIELD_DAY}
                                                <i className="customic ic-down-arrow ml-auto"></i>
                                            </a>
                                        </div>
                                        <div id="fieldDetails" className={`collapse ${activeStage === S2S_STAGE.FIELD_DAY ? 'show accordion-body' : ''}`} aria-labelledby="fieldDetailsHeading" data-parent="#generalInfoForm">
                                            <FieldDayView fieldDayStage={fieldDayStage} />
                                        </div>
                                    </div> : null
                                }


                                {/* Harvest Details */}
                                {harvestDetailStage !== undefined && harvestDetailStage !== null ?
                                    <div>
                                        <div id="harvestDetailsHeading" className="d-md-none accordion-heading">
                                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#harvestDetails" aria-expanded="false" aria-controls="harvestDetails">
                                                {SAMPLE_TO_SALE_SCREEN.HARVEST_DETAILS}
                                                <i className="customic ic-down-arrow ml-auto"></i>
                                            </a>
                                        </div>

                                        <div id="harvestDetails" className={`collapse ${activeStage === S2S_STAGE.HARVEST_DETAILS ? 'show accordion-body' : ''}`} aria-labelledby="harvestDetailsHeading" data-parent="#generalInfoForm">

                                            {activity?.crop_name === S2S_CROP.COTTON ?
                                                <HarvestCottonView harvestDetailStage={harvestDetailStage}
                                                    hybridName={activity?.hybrid_name}
                                                /> : null
                                            }

                                            {activity?.crop_name === S2S_CROP.RICE ?
                                                <HarvestRiceView harvestDetailStage={harvestDetailStage}
                                                    hybridName={activity?.hybrid_name}
                                                /> : null
                                            }

                                            {activity?.crop_name === S2S_CROP.MILLET || activity?.crop_name === S2S_CROP.MUSTARD ?
                                                <HarvestMilletView harvestDetailStage={harvestDetailStage}
                                                    hybridName={activity?.hybrid_name} /> : null
                                            }

                                            {this.isVegCrop() ?
                                                <HarvestVegView harvestDetailStage={harvestDetailStage}
                                                    hybridName={activity?.hybrid_name}
                                                /> : null
                                            }

                                        </div>
                                    </div> : null
                                }


                                {/* Field Damage */}
                                {fieldDamageStage !== undefined && fieldDamageStage !== null ?
                                    <div>
                                        <div id="fieldDamageHeading" className="d-md-none accordion-heading">
                                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#fieldDamage" aria-expanded="false" aria-controls="fieldDamage">
                                                {SAMPLE_TO_SALE_SCREEN.FIELD_DAMAGE}
                                                <i className="customic ic-down-arrow ml-auto"></i>
                                            </a>
                                        </div>

                                        <div id="fieldDamage" className={`collapse ${activeStage === S2S_STAGE.FIELD_DAMAGE ? 'show accordion-body' : ''}`} aria-labelledby="fieldDamageHeading" data-parent="#generalInfoForm">
                                            <FieldDamageView fieldDamageStage={fieldDamageStage} />
                                        </div>

                                    </div> : null
                                }

                            </div>
                        </div>
                    </div>

                    <AcceptRejectButton
                        activity={activity}
                        handleAcceptButton={this.handleAcceptButton}
                        handleRejectButton={this.handleRejectButton}
                    />

                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
            </div>
        )
    }
}

export default withRouter(SampleToSaleDetails);